module.exports = __webpack_public_path__ + "img/icon_security.3ce7ef64.svg";